<template>
  <power-bi code="eyJrIjoiNmM5ZWMzODAtN2Y4Ni00ZDI1LWFlZDItZGRkNTNlZTc1ZWEwIiwidCI6ImM4NDJjMWQ5LWQzNjQtNDcxNi1iN2UzLWNhNDgxYTIzZDZhYyJ9" />
</template>

<script>
import PowerBi from '../components/PowerBi.vue';

export default {
    components: {
        PowerBi,
    },
};
</script>
